import { PdfContext } from 'utils/context';
import CoverPage from './Pages/CoverPage';
import './pdfComponent.style.scss';
import ParcelSynthesis from './Pages/ParcelSynthesis';
import GrossMarginGraph from './Pages/GrossMarginGraph';
import KeyNumberPage from './Pages/KeyNumberPage';
import CapPoints from './Pages/CapPoints';
import Constraint from './Pages/Constraint';
import ObligationRestriction from './Pages/ObligationRestriction';
import GraphPerYearPage from './Pages/GraphPerYear';
import CultureListConventional from './Pages/CultureListConventional';
import KeyNumberNitrogenPage from './Pages/KeyNumberNitrogenPage';
import CultureListOrganic from './Pages/CultureListOrganic';

const PdfComponent = ({ data, results, totalFooterMargin }) => {
  const {
    proposal,
    constraints,
    pac,
    obligationRestrictions,
    isNitrogenASelectedConstraint,
    isExtraBiomassASelectedConstraint,
    invertedCultures,
    forecastCampaign,
  } = data;

  //update footerMargin with value defined in PdfDocument
  const root = document.documentElement;
  root.style.setProperty('--height-pdf', `calc(21cm - ${totalFooterMargin}px)`);
  root.style.setProperty('--margin-bottom-pdf', `${totalFooterMargin}px`);

  const result = Object.entries(results.suggestions).find(([key, _]) => key === proposal);
  const suggest = result[1];
  data = { ...data, suggest: suggest };

  const hasConstraints =
    constraints.typeCoProduit.length > 0 || constraints.autres.length > 0 || constraints?.pac;
  const hasPacTable = pac.length > 0;
  const hasObligationRestriction = obligationRestrictions.length > 0;
  const hasInvertedCultures = invertedCultures.length > 0;

  return (
    <PdfContext.Provider value={data}>
      <CoverPage />
      {result && (
        <>
          <ParcelSynthesis
            isNitrogenASelectedConstraint={isNitrogenASelectedConstraint}
            isExtraBiomassASelectedConstraint={isExtraBiomassASelectedConstraint}
            forecastCampaign={forecastCampaign}
          />
          <GrossMarginGraph />
          <KeyNumberPage />
          {isNitrogenASelectedConstraint && <KeyNumberNitrogenPage />}
          {hasPacTable && <CapPoints />}
          <GraphPerYearPage />
          {hasObligationRestriction && <ObligationRestriction />}
          {hasConstraints && <Constraint />}
          <CultureListConventional />
          {hasInvertedCultures && <CultureListOrganic />}
        </>
      )}
    </PdfContext.Provider>
  );
};

export default PdfComponent;
